import { render, staticRenderFns } from "./CheckboxSize.vue?vue&type=template&id=621ec59a"
import script from "./CheckboxSize.vue?vue&type=script&lang=js"
export * from "./CheckboxSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports